<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" color="primary">
      <inline-svg
        :src="require('@/assets/svg/check_white.svg')"
        width="19"
        height="22"
      />
      Confirm Interview
    </SecondaryButton>
    <EditInterviewParticipantStatusDialog
      label="Interview adjustments"
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
      title="Are you sure you want to confirm your interview?"
      buttonText="Confirm Interview"
      status="accepted"
      :hideTextarea="!isAdjustmentRequired"
    />
  </BaseAction>
</template>

<script>
import EditInterviewParticipantStatusDialog from "@/views/interviews/dialogs/EditInterviewParticipantStatusDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { isPermissioned } from "@/utils/permissions";
import InlineSvg from "vue-inline-svg";

export default {
  name: "ConfirmInterviewAction",
  components: {
    BaseAction,
    SecondaryButton,
    EditInterviewParticipantStatusDialog,
    InlineSvg
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  computed: {
    isAdjustmentRequired() {
      return isPermissioned(
        "interviews.edit-interview-participant.adjustment-required"
      );
    }
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
